import { useCatalogQuery, toProductList } from "./useProductsBySubCategory";

/*
export interface UseFetchProductsDataHandler = (
  page: number,
  sortBy: string,
  slug: string
  selectedSubcategories: string[],
  filterNutriScore: string[],
  query: string,
  desktopFilters: { discounts_and_offer: string[] }
) => {}
*/

// Each filter combination is cached on its own, so going back to a category or
// undoing a filter shows the products straight away. Every page is its own
// cache entry: pages are not accumulated into one list.
export const useFetchProductsData = (props) => {
  const {
    page,
    sortBy,
    slug,
    selectedSubcategories,
    filterBrands,
    filterNutriScore,
    query,
    desktopFilters
  } = props;

  const selectedSubcategoriesIds = selectedSubcategories.length > 0
    ? selectedSubcategories.join()
    : null;

  const filterBrandsIds = filterBrands.length > 0 ? filterBrands.join() : null;
  const discount = desktopFilters.discounts_and_offer.length > 0 ? true : null;
  const nutritionScores = filterNutriScore.length > 0 ? filterNutriScore.join() : null

  const { data, loading, error } = useCatalogQuery("/public/products", {
    params: {
      page: page,
      limit: 100,
      sort_by: sortBy,
      sub_category: slug.split("_")[1],
      sub_subcategories: selectedSubcategoriesIds,
      brands: filterBrandsIds,
      nutri_scores: nutritionScores,
      search_term: query ? query : null,
      discount: discount,
    },
    transform: (data) => ({ count: data.count, products: toProductList(data.results) }),
  });

  return [
    data?.products ?? [],
    {
      loading,
      count: data?.count ?? 0,
      error: error?.response?.status === 404 ? "PAGE_NOT_FOUND" : undefined,
    },
  ];
}
